export default __webpack_public_path__ + "assets/uv-index-3.06563803.svg";